module.exports = __webpack_public_path__ + "static/money-transfer-app-cover-72a9d87532009672820a6c6d871f8fb3.png";